import { useState } from "react";
import { Box, Container, Tab, Tabs, makeStyles } from "@material-ui/core";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { fontFamily } from "../../../../app/theme";

export const ElectricityAnalysis = () => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  const [value, setValue] = useState(0);
  const classes = useStyles();

  return (
    <Box>
      <Container maxWidth="lg">
        <Box
          fontSize={isMoreThanSm ? "16px" : "14px"}
          mt={isMoreThanMd ? "0" : "60px"}
          textAlign={"center"}
          mb={"35px"}
          fontWeight={400}
          color={isMoreThanSm ? "#4b5462" : "rgba(17, 21, 33, 0.65)"}
        >
          Below is a sample of a live monitoring app that you will have access to.
        </Box>
        <Box maxWidth={"970px"} px={isMoreThanMd ? 0 : "21px"} margin={"0 auto"}>
          {!isMoreThanMd && (
            <Tabs
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="fullWidth"
              className={classes.tabs}
            >
              <Tab label="July 2022" />
              <Tab label="October 2022" />
            </Tabs>
          )}
          <Box display={"flex"} mt={isMoreThanMd ? 0 : "30px"} mb={"34px"}>
            {(isMoreThanMd || value === 0) && (
              <Box pr={isMoreThanMd ? "15px" : 0}>
                <Box width={"100%"} height={isMoreThanMd ? "500px" : "fit-content"}>
                  <img
                    src="images/quote/electricity_7.webp"
                    alt="july-huawei"
                    width={isMoreThanMd ? "auto" : "100%"}
                    height={isMoreThanMd ? "100%" : "auto"}
                    style={{ objectFit: "cover" }}
                  />
                </Box>
              </Box>
            )}
            {(isMoreThanMd || value === 1) && (
              <Box pl={isMoreThanMd ? "15px" : 0}>
                <Box width={"100%"} height={isMoreThanMd ? "500px" : "fit-content"}>
                  <img
                    src="images/quote/electricity_10.webp"
                    alt="Huawei-October"
                    width={isMoreThanMd ? "auto" : "100%"}
                    height={isMoreThanMd ? "100%" : "auto"}
                    style={{ objectFit: "cover" }}
                  />
                </Box>
              </Box>
            )}
          </Box>
          <Box fontSize={isMoreThanSm ? "16px" : "14px"} lineHeight={1.5} textAlign={"center"} color={"#4b5462"}>
            The online monitoring app allows users to track their production, consumption and carbon savings in real
            time which allows users to become more energy conscious when using electricity. In the graphs above the
            green line, 'Yield', is the electricity produced from the Solar PV system. A user can see how much of the
            Solar PV produced is used in the property and how much is feed back to the grid which credit can be obtained
            for. The blue line, 'Consumption', is the total amount of electricity used in the property, from this a user
            can see how much of their electricity consumption comes from Solar PV and how much is bought from the grid.
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  tabs: {
    "& .MuiTab-root": {
      "boxShadow": "none",
      "margin": 0,
      "borderBottom": "2px solid #d1d1d1",
      "& .MuiTab-wrapper": {
        fontSize: "14px",
        fontWeight: 500,
        color: "#160337",
        fontFamily: fontFamily.Axiforma,

        [theme.breakpoints.down("xs")]: {
          fontSize: "12px"
        }
      }
    },
    "& .MuiTabs-indicator": {
      bottom: "10px",
      backgroundColor: "#160337 !important"
    }
  }
}));
